import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { toUpper } from "ramda";

import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  badge: {
    background: "rgba(125, 218, 252, 0.5)",
    borderRadius: 4,
    padding: "8px 12px",
    gap: 10,
    width: "auto",
    height: 32,
  },

  mediaType: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: "16px",
    color: theme.palette.primary.main,
  },
}));

const MediaTypeBadge = ({ group }) => {
  const classes = useStyles();
  return (
    <div className={classes.badge}>
      <Typography className={classes.mediaType}>
        {toUpper(group.mediaType)}
      </Typography>
    </div>
  );
};

export default MediaTypeBadge;
